import { createSelector } from 'reselect';
import { getProjectViewData } from 'src/modules/project-view/selectors/getProjectViewData';

export const getProjectSettings = createSelector([
  getProjectViewData,
], (data) => data.settings);
